import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import DialogBackdrop from "./DialogBackdrop";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

const DomainErrorModal = ({
  modalState,
  setModalState,
  errorInfo,
  setCurrentStep,
  domainError,
  setDomainError,
  title,
}) => {
  const { t } = useTranslation();
  const setStep = () => {
    setModalState(false);
    setCurrentStep(2);
    setDomainError(0);
  };
  const setClose = () => {
    setModalState(false);
    setDomainError(0);
  };

  return (
    <>
      <Transition appear show={modalState} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={() => setClose()}
        >
          <DialogBackdrop />
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-2xl p-6 mt-32 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h2"
                  className="font-body text-xl font-bold text-left"
                >
                  {title ? title : t("CustomerRegister-error-modal-text-1")}
                </Dialog.Title>
                <button
                  className="ui-default-dialog-close"
                  onClick={() => setModalState(false)}
                >
                  <svg
                    className="ui-icon h-3.5 w-3.5"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-close"></use>
                  </svg>
                </button>
                <hr />
                <Dialog.Description>
                  {domainError === 2 ? (
                    <div>
                      <div>{errorInfo}</div>
                      <Link
                        to="/guest/claims"
                        className="inline-block mb-4 mr-8 text-blue-600"
                      >
                        {t("CustomerRegister-error-modal-text-2")}
                      </Link>
                    </div>
                  ) : (
                    <div>{errorInfo}</div>
                  )}
                </Dialog.Description>
                {domainError !== 1 ? (
                  <div className="block text-right mt-6">
                    <button
                      className="ui-btn-primary min-w-[140px]  mt-4"
                      aria-label="Go to login page"
                      onClick={() => setClose()}
                    >
                      {t("CustomerRegister-error-modal-button-1")}
                    </button>
                  </div>
                ) : (
                  <div className="block text-right mt-6">
                    <button
                      className="ui-btn-primary min-w-[140px]  mt-4"
                      aria-label="Go to login page"
                      onClick={() => setStep()}
                    >
                      {t("CustomerRegister-error-modal-button-2")}
                    </button>
                  </div>
                )}
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default DomainErrorModal;
